import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var BlogHeaderQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query blogHeaderQuery {\n    blogHeader {\n      LinksGroup {\n        label\n        linkList {\n          value\n          href\n          alt\n        }\n      }\n    }\n  }\n"])));
export default BlogHeaderQuery;